import { ItemType } from "../../new-components/Header/Menu/MenuGroup/MenuGroup"

export enum RoleTypes {
  CUSTOMER = "customer",
  EMPLOYEE = "employee",
}

export type RoleItem = {
  node: {
    name: string
    slug: string
    type: string
  }
}

export type RolesQuery = {
  allRolesJson: {
    edges: Array<RoleItem>
  }
}

export const roles: Record<string, Array<ItemType>> = {
  roles: [
    {
      name: "CX Professional",
      slug: "/roles/cx-professional",
    },
    {
      name: "Operations",
      slug: "/roles/operations",
    },
    {
      name: "Marketing",
      slug: "/roles/marketing",
    },
    {
      name: "Data Analyst",
      slug: "/roles/data-analyst",
    },
    {
      name: "Human Resources",
      slug: "/roles/human-resources",
    },
  ],
}
